<template>
  <div>
    <div
        v-if="validatedField.value"
        v-html="validatedField.value"
        :class="className">
    </div>

  </div>
</template>

<script>

import FormValidatedField from "@/components/forms/FormValidatedField";
import yaml from "js-yaml"

export default {
  name: "TextReadOnly",
  components: {},
  created() {
  },

  async mounted() {
    let validatedField = this.validatedField;
    let renererOptions = yaml.load(validatedField.formFieldConfig.rendererOptions);

    if(Array.isArray(renererOptions)) {
        renererOptions.forEach(obj => {
          if(obj.hasOwnProperty('className')) {
            this.className = obj.className
          }
        })
    } else {
      if(renererOptions.className != null) {
        this.className = renererOptions.className;
      }
    }
  },

  props: {
    validatedField: {type: FormValidatedField, required: true},
  },

  methods: {
    setReadOnly(readOnly) {

    },
  },

  data: () => ({
    className: ''
  })
}
</script>

